import { render } from "./Tipos_lineas.vue?vue&type=template&id=1605d705&scoped=true"
import script from "./Tipos_lineas.vue?vue&type=script&lang=js"
export * from "./Tipos_lineas.vue?vue&type=script&lang=js"

import "./Tipos_lineas.vue?vue&type=style&index=0&id=1605d705&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1605d705"]])

export default __exports__